import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-angle-up',
    templateUrl: './angle-up.component.html',
    styleUrls: ['./angle-up.component.css'],
    standalone: false
})
export class AngleUpComponent {
  @Input() size = 24;
  @Input() color = '#000';
}
